import { tinycolor as S } from "./theme-generator.js";
const d = [{
    name: "primitive/black",
    type: "FILL",
    value: "#000000ff"
  }, {
    name: "primitive/white",
    type: "FILL",
    value: "#ffffffff"
  }, {
    name: "primitive/black/alpha",
    type: "FILL",
    value: "#0000000f"
  }, {
    name: "primitive/white/alpha",
    type: "FILL",
    value: "#ffffff14"
  }, {
    name: "primitive/neutral/0",
    type: "FILL",
    value: "#ffffffff"
  }, {
    name: "primitive/accent/300",
    type: "FILL",
    value: "#b6f1ebff"
  }, {
    name: "primitive/neutral/1100",
    type: "FILL",
    value: "#292929ff"
  }, {
    name: "primitive/neutral/400",
    type: "FILL",
    value: "#bfbfbfff"
  }, {
    name: "primitive/neutral/500",
    type: "FILL",
    value: "#949494ff"
  }, {
    name: "primitive/accent/500",
    type: "FILL",
    value: "#1fa1adff"
  }, {
    name: "primitive/neutral/800",
    type: "FILL",
    value: "#666666ff"
  }, {
    name: "primitive/neutral/1000",
    type: "FILL",
    value: "#383838ff"
  }, {
    name: "primitive/neutral/900",
    type: "FILL",
    value: "#525252ff"
  }, {
    name: "primitive/accent/800",
    type: "FILL",
    value: "#003d52ff"
  }, {
    name: "primitive/accent/1200",
    type: "FILL",
    value: "#001824ff"
  }, {
    name: "primitive/accent/100",
    type: "FILL",
    value: "#e2f9f7ff"
  }, {
    name: "primitive/accent/50",
    type: "FILL",
    value: "#f8fefdff"
  }, {
    name: "primitive/neutral/100",
    type: "FILL",
    value: "#f1f1f1ff"
  }, {
    name: "primitive/neutral/600",
    type: "FILL",
    value: "#8c8c8cff"
  }, {
    name: "primitive/neutral/1200",
    type: "FILL",
    value: "#1f1f1fff"
  }, {
    name: "primitive/neutral/200",
    type: "FILL",
    value: "#e6e6e6ff"
  }, {
    name: "primitive/neutral/50",
    type: "FILL",
    value: "#fbfbfbff"
  }, {
    name: "primitive/accent/1100",
    type: "FILL",
    value: "#001f2eff"
  }, {
    name: "primitive/accent/1300",
    type: "FILL",
    value: "#000e14ff"
  }, {
    name: "primitive/accent/900",
    type: "FILL",
    value: "#003142ff"
  }, {
    name: "primitive/neutral/700",
    type: "FILL",
    value: "#737373ff"
  }, {
    name: "primitive/accent/200",
    type: "FILL",
    value: "#ccf5f1ff"
  }, {
    name: "primitive/accent/600",
    type: "FILL",
    value: "#0f6b8aff"
  }, {
    name: "primitive/accent/1000",
    type: "FILL",
    value: "#002838ff"
  }, {
    name: "primitive/accent/700",
    type: "FILL",
    value: "#004c66ff"
  }, {
    name: "primitive/accent/400",
    type: "FILL",
    value: "#5ec0c9ff"
  }, {
    name: "primitive/neutral/1300",
    type: "FILL",
    value: "#141414ff"
  }, {
    name: "primitive/neutral/300",
    type: "FILL",
    value: "#d9d9d9ff"
  }],
  C = () => d.sort((r, e) => {
    const t = m(r.name),
      a = m(e.name);
    return t < a ? -1 : t > a ? 1 : 0;
  }),
  T = () => {
    C();
    const r = {},
      e = {},
      t = /* @__PURE__ */new Set();
    d.forEach(({
      name: c,
      value: v
    }) => {
      const i = m(c);
      !Number.isNaN(i) && i !== 0 && t.add(i), c.includes("accent") && t.has(i) && (r[i] = v), c.includes("neutral") && t.has(i) && (e[i] = v);
    });
    const a = Array.from(t),
      u = a[Math.floor(a.length / 2)],
      f = a.indexOf(u);
    return {
      accentPalette: r,
      neutralPalette: e,
      shadeLevels: a,
      baseShadeLevel: u,
      baseShadeLevelIndex: f,
      minShadeLevel: a[0],
      maxShadeLevel: a[a.length - 1],
      darkerShadesCount: a.slice(f + 1).length,
      lighterShadesCount: a.slice(0, f).length
    };
  },
  D = r => {
    const e = d.find(t => S(t.value).toHexString() === S(r).toHexString());
    return e == null ? void 0 : e.name;
  },
  m = r => +r.substring(r.lastIndexOf("/") + 1),
  n = T(),
  R = {
    greenHue: 90,
    blueHue: 180,
    violetHue: 240,
    baseSaturation: 0.6,
    maxLightness: 0.97,
    minLightness: 0.07
  },
  w = {
    previousFirstPair: n.shadeLevels.slice(n.baseShadeLevelIndex - 2, n.baseShadeLevelIndex),
    previousSecondPair: n.shadeLevels.slice(n.baseShadeLevelIndex - 4, n.baseShadeLevelIndex - 2),
    nextFirstPair: n.shadeLevels.slice(n.baseShadeLevelIndex + 1, n.baseShadeLevelIndex + 3),
    nextSecondPair: n.shadeLevels.slice(n.baseShadeLevelIndex + 3, n.baseShadeLevelIndex + 5),
    previousRest: n.shadeLevels.slice(1, n.baseShadeLevelIndex - 4),
    nextRest: n.shadeLevels.slice(n.baseShadeLevelIndex + 5)
  },
  N = (r, e) => {
    const {
        h: t,
        s: a,
        l: u,
        a: f
      } = r,
      {
        lighterShadesCount: c,
        darkerShadesCount: v,
        baseShadeLevel: i,
        minShadeLevel: h
      } = n,
      {
        baseSaturation: s,
        maxLightness: p,
        minLightness: F,
        greenHue: l,
        blueHue: y,
        violetHue: I
      } = R,
      {
        previousFirstPair: g,
        previousSecondPair: b,
        previousRest: x,
        nextFirstPair: H,
        nextSecondPair: P,
        nextRest: o
      } = w,
      L = Math.round((p - u) / c * 100) / 100,
      k = Math.round((u - F) / v * 100) / 100,
      M = Math.round((a - s) / c * 100) / 100;
    return e.level === i && (e.currentHue = t, e.currentSaturation = a, e.currentLightness = u), e.level === h && (e.currentHue = t < l ? t + 4 : t - 4, e.currentSaturation = a > s ? s : a, e.currentLightness = p), e.level > h && e.level < i && (e.currentSaturation = a > s ? e.currentSaturation + M * s : a, x.includes(e.level) ? (e.currentHue = t < l ? t + 3 : t - 3, e.currentLightness -= L * 0.5) : b.includes(e.level) ? (e.currentHue = t < l ? t + 2 : t - 2, e.currentLightness -= L) : g.includes(e.level) && (e.currentHue = t < l ? t + 1 : t - 1, e.currentLightness -= L * 1.4)), e.level > i && (e.currentSaturation = a, e.currentLightness -= k, H.includes(e.level) ? e.currentHue = t < l ? t - 1 : t + 1 : P.includes(e.level) ? e.currentHue = t < l ? t - 2 : t + 2 : o.includes(e.level) && (e.currentHue = t < l ? t - 3 : t + 3)), {
      hue: e.currentHue,
      saturation: Math.round(e.currentSaturation * 100) / 100,
      lightness: e.currentLightness,
      alpha: f,
      neutralHue: t + 10,
      neutralSaturation: a < 0.15 ? 0 : t > y && t < I ? 0.15 : t >= I ? 0.1 : 0.05,
      neutralLightness: e.currentLightness,
      neutralAlpha: f
    };
  };
export { N as calculateHSLColor, R as defaultHSLOptions, n as defaultThemeData, T as getDefaultThemeData, D as getMatchingPrimitiveToken, m as getTokenLastSubstring, w as shadePairs };